export default __webpack_public_path__ + "static/media/screen12.dc3a20ad.png";